export default __webpack_public_path__ + "static/media/Apple (6).c62c1435.jpg";